import React from 'react';
import { useSpaceAccess } from '../../nucleus/access';
import { Empty } from './Empty';

// NO ACCESS: a member whose realm grants nothing reads none of the group's data.
// The pages that show it (the identity graph, home's identity figure, data and
// export, trash, review) say so in one quiet line, the same everywhere. Nothing
// when they can read.
export default function NoAccess({ className = '' }) {
    const { noAccess, noAccessLine } = useSpaceAccess();
    if (!noAccess) return null;
    return <Empty className={`nx-no-access ${className}`.trim()} role="status">{noAccessLine}</Empty>;
}
